import styled from "styled-components";

export const SortIndicatorContainer = styled.div`
    margin-left:5px;
    margin-right:5px;
    margin-top:5px;
`;